import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
export function WhatsAppButton() {
  return <motion.a href="https://wa.me/message/CMWGN4MINPN2I1" target="_blank" rel="noopener noreferrer" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    duration: 0.3
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.95
  }} className="fixed bottom-6 right-6 z-50 group" aria-label="Contactar soporte por WhatsApp" data-id="element-156">
      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none" data-id="element-157">
        <div className="bg-chocolate-dark text-cream px-4 py-2 rounded-lg shadow-warm-lg whitespace-nowrap text-sm font-medium" data-id="element-158">
          ¿Dudas? Comunícate con soporte
          <div className="absolute top-full right-6 w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-chocolate-dark" data-id="element-159"></div>
        </div>
      </div>

      {/* WhatsApp Button */}
      <div className="bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-4 shadow-warm-lg flex items-center justify-center transition-colors" data-id="element-160">
        <MessageCircleIcon className="w-7 h-7" data-id="element-161" />
      </div>

      {/* Pulse animation */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" data-id="element-162"></span>
    </motion.a>;
}